import { PEOPLE_MOVEMENT_FLAG, REGISTRIES_RECORDS_FLAG } from './registryFlags';
const enc = (v)=>encodeURIComponent(v ?? '');
/**
 * The eight registry record routes (REG-08) and their flag-off fallbacks. The
 * fallbacks are the drawer URLs the list already understands, so a new link
 * opened with the flag off lands on the same record.
 */ export const REGISTRY_RECORD_ROUTES = {
    contact: {
        path: 'registries/contacts/:id',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Contacts',
        tab: 'contacts',
        pageTitle: 'Contact',
        fallback: (p)=>`/registries?tab=contacts&record=${enc(p.id)}`
    },
    company: {
        path: 'registries/companies/:id',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Companies',
        tab: 'companies',
        pageTitle: 'Company',
        fallback: (p)=>`/registries?tab=companies&record=${enc(p.id)}`
    },
    lcatEntry: {
        path: 'registries/labor-categories/entries/:entryId',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Labor Categories',
        tab: 'lcats',
        pageTitle: 'Labor category',
        fallback: (p)=>`/registries?tab=lcats&record=${enc(p.entryId)}`
    },
    lcatAnchor: {
        path: 'registries/labor-categories/:anchorId',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Labor Categories',
        tab: 'lcats',
        pageTitle: 'Labor category',
        // Anchors have no drawer today; the Compare sub-view preselects ?anchor=.
        fallback: (p)=>`/registries?tab=lcats&view=compare&anchor=${enc(p.anchorId)}`
    },
    vehicle: {
        path: 'registries/vehicles/:id',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Contract Vehicles',
        tab: 'vehicles',
        pageTitle: 'Contract vehicle',
        fallback: (p)=>`/registries?tab=vehicles&record=${enc(p.id)}`
    },
    govorg: {
        path: 'registries/gov-orgs/:id',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Government Orgs',
        tab: 'govorgs',
        pageTitle: 'Government org',
        fallback: (p)=>`/registries?tab=govorgs&record=${enc(p.id)}`
    },
    reviewQueue: {
        path: 'registries/review-queue',
        flag: REGISTRIES_RECORDS_FLAG,
        kindLabel: 'Review queue',
        tab: 'lcats',
        pageTitle: 'Review queue',
        fallback: ()=>'/registries?tab=lcats'
    },
    peopleMovement: {
        path: 'registries/people-movement',
        flag: REGISTRIES_RECORDS_FLAG,
        alsoRequires: PEOPLE_MOVEMENT_FLAG,
        kindLabel: 'People movement',
        tab: 'contacts',
        pageTitle: 'People movement',
        fallback: ()=>'/registries?tab=contacts'
    }
};
